// extracted by mini-css-extract-plugin
export var bordersection = "SectionCentrePromotedDogs-module--bordersection--4f920";
export var bordertop = "SectionCentrePromotedDogs-module--bordertop--cc9f2";
export var showalldogs = "SectionCentrePromotedDogs-module--showalldogs--a58ad";
export var spotlightdogsinner = "SectionCentrePromotedDogs-module--spotlightdogsinner--b60c8";
export var titlewrapper = "SectionCentrePromotedDogs-module--titlewrapper--0bdc9";